import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBbz4keWBlDK3kBLvEpMhitVHnd2UPasu0",
  authDomain: "todo-app-ahjim.firebaseapp.com",
  projectId: "todo-app-ahjim",
  storageBucket: "todo-app-ahjim.appspot.com",
  messagingSenderId: "81547345375",
  appId: "1:81547345375:web:6e708f6ded7c5b205ad86a",
  measurementId: "G-Y98X0YHBYP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { analytics, auth, db };
